import { inArray } from "jquery";
import moment from "moment";
import { MSDropDown } from "../../ms_front_lib/components/MSDropDown";
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeFr from 'air-datepicker/locale/fr';
// import { PaneShowMovie } from "../pages/PaneShowMovie";

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

export class Prog {
  constructor(prog) {
    // console.log(prog)
    this.m_prog = prog;
    this.slider_dragging = false;
    this.air_dp = null;
    this.website_active = gl_config.type == "site" && gl_config.site.website_active ? gl_config.site.website_active : gl_config.type == "site" ? false : true;
  }

  getAllEvents() {
    return this.m_prog && this.m_prog.schedule && this.m_prog.schedule.events
      ? this.m_prog.schedule.events
      : [];
  }

  getDataSchedulesCards(movieId) {
    const currentMovie = this.m_prog.schedule.events.find(
      (movie) => movie.id === movieId
    );
    if (!currentMovie) {
      console.log("Movie not found");
      return [null, null];
    }

    const currentMovieSessions = currentMovie.sessions.map(
      (session) => session.date
    );

    const currentMoviesBookingUrl = currentMovie.sessions.map(
      (session) => session.booking_url
    );
    const currentMovieBookingData = currentMovie.sessions.map((session) => ({
      date: session.date,
      booking_url: session.booking_url,
      formats: session.formats,
      features: session.features,
      id: session.id,
    }));

    return [
      currentMovieSessions,
      currentMoviesBookingUrl,
      currentMovieBookingData,
    ];
  }

  getScheduledDays(movieId) {
    const currentDate = moment();
    const res = [];
    this.m_prog.schedule.events.forEach((movie) => {
      if (!movieId || movie.id == movieId) {
        movie.sessions.forEach((session) => {
          if(currentDate.diff(moment(session.date, "YYYYMMDDHHmm"),"m") <= 0){
            const date = session.date.substring(0, 8);
            if (!res.includes(date)) {
              res.push(date);
            }
          }
        });
      }
    });
    return res.sort();
  }

  getAllMoviesSelectedDate(clickedCardDate, iMovieId) {
    const today = moment();
    const now = today.format("YYYYMMDD");
    let time_now = moment().format("HHmm");
    const moviesToDisplay = {};
    // const paneShowMovieInstance = new PaneShowMovie();
    // const CurrentMovieId = paneShowMovieInstance.checkMovieIDUrl();
    this.m_prog.schedule.events.forEach((movie) => {
      let common_features = []; // features communes aux séances, on les met sur le film
      movie.sessions.forEach((session) => {
        const date = session.date.substring(0, 8);
        if (date === clickedCardDate && iMovieId !== movie.id) {
          // séance dépassée
          if(date == now && session.date.substring(8,12) < time_now){
            return;
          }
          if(session.seat_booking && session.features.indexOf("hall_map")<0){
            session.features.push("hall_map");
          }
          if(session.features && session.features.length>0){
            if(common_features.length<=0){
              common_features = Object.assign([],session.features);
            }else{
              common_features.forEach(feature => {
                if($.inArray(feature,session.features)<0){
                  var index = common_features.indexOf(feature);
                  if(index>=0){
                    common_features.splice(index,1);
                  }
                }
              });
            }
          }

          if (!moviesToDisplay[movie.id]) {
            moviesToDisplay[movie.id] = {
              art_et_essai_actif: movie.art_et_essai_actif,
              title: movie.title,
              genres: movie.genres,
              localized_genres: movie.localized_genres ? movie.localized_genres : [],
              id: movie.id,
              booking_url: session.booking_url,
              bill_url: movie.bill_url,
              features: [],
              formattedDuration: movie.duration ? this.timeConvert(movie.duration) : "",
              sessions: [],
              certification: this.ParseCertification(movie.certification_id),
              trailer_url: movie.trailer_url,
              custom_tags: movie.custom_tags
            };
          }
          moviesToDisplay[movie.id].sessions.push(session);
        }

        // console.log(common_features)

      });
      if(moviesToDisplay[movie.id]){
        moviesToDisplay[movie.id].features = common_features;
      }
      
    });
    return Object.values(moviesToDisplay);
  }

  timeConvert(minutes) {
    const num = minutes;
    const hours = num / 60;
    const rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    rminutes = rminutes?.toString().length == 1 ? "0" + rminutes : rminutes;
    return rhours + "h" + rminutes;
  }

  // Renvoi la prog sur la 7 jours glissant
  get_current_week_program() {
    let results = [];
    const today = moment();
    let time_now = moment().format("HHmm");
    const events = this.m_prog.schedule.events;
    let nb_day_to_next_week_start = 7; // on prends une semaine glissante
    
    for(var i=0;i<nb_day_to_next_week_start;i++){
      let day = today.clone().add(i,'days');
      let tab_event = [];
      events.forEach(event => {
        const movie_session_day = event.sessions.filter(session => session.date.substring(0,8) == day.format("YYYYMMDD"));
        if(movie_session_day && movie_session_day.length>0){
          let common_features = []; // features communes aux séances, on les met sur le film
          movie_session_day.forEach((session,index) => {
            let date_session = session.date.substring(0,8);
            let time_session = session.date.substring(8,12);
            if(date_session == today.format("YYYYMMDD") && time_session < time_now){
              movie_session_day.splice(index,1);
            }
            // if(!session.booking_url){
            //   movie_session_day.splice(index,1);
            // }
            if(event.art_et_essai_actif){
              if(!session.features){
                  session.features = [];
              }
              if(session.features.indexOf("art_et_essai")<=0){
                  session.features.push("art_et_essai");
              }
            }
            if(session.seat_booking && session.features.indexOf("hall_map")<0){
              session.features.push("hall_map");
            }
            if(session.features && session.features.length>0){
              if(common_features.length<=0){
                common_features = Object.assign([],session.features);
              }else{
                common_features.forEach(feature => {
                  if($.inArray(feature,session.features)<0){
                    var index = common_features.indexOf(feature);
                    if(index>=0){
                      common_features.splice(index,1);
                    }
                  }
                });
              }
            }
          });

          if(movie_session_day.length > 0){
            let my_event = Object.assign({},"");
            my_event.id = event.id;
            my_event.title = event.title;
            my_event.certification = this.ParseCertification(event.certification_id);
            my_event.features = common_features;

            tab_event.push({
              event : my_event,
              sessions : movie_session_day
            });
          }
        }
      });

      if(tab_event.length>0){
        results.push({
          date : day,
          data : tab_event
        })
      }
    }    

    return results;
  }

  // Renvoi la prog sur la semaine cinématographique en cours
  get_week_cine_prog(){
    let results = {};
    results.events = []
    const today = moment();
    let time_now = moment().format("HHmm");
    const events = Object.assign([],this.m_prog.schedule.events);
    let nb_day_to_next_week_start = 0;

    let first_day_of_week = null;
    let last_day_of_week = null;

    switch(moment().isoWeekday()){
      case 1:
        first_day_of_week = moment().subtract("5","days");
        last_day_of_week = moment().add("1","days");
        break;
      case 2:
        first_day_of_week = moment().subtract("6","days");
        last_day_of_week = moment();
        break;
      case 3:
        first_day_of_week = moment();
        last_day_of_week = moment().add("6","days");
        break;
      case 4:
        first_day_of_week = moment().subtract("1","days");
        last_day_of_week = moment().add("5","days");
        break;
      case 5:
        first_day_of_week = moment().subtract("2","days");
        last_day_of_week = moment().add("4","days");
        break;
      case 6:
        first_day_of_week = moment().subtract("3","days");
        last_day_of_week = moment().add("3","days");
        break;
      case 7:
        first_day_of_week = moment().subtract("4","days");
        last_day_of_week = moment().add("2","days");
        break;
      default:
        break;
    }

    // Si on veut 7 jours glissants, garder les 2 lignes suivantes
    // first_day_of_week = moment();
    // last_day_of_week = moment().add("6","days");

    results.first_day = first_day_of_week;
    results.last_day = last_day_of_week;
    
    events.sort(function(a,b){
      if(a.sessions<b.sessions){
          return 1;
      };
      if(a.sessions>b.sessions){
          return -1;
      };
      return 0;
    });
    
    events.forEach(event => {
      let tab_date = [];
      for(var i=0; i<7; i++){
        let day = first_day_of_week.clone().add(i,'days');
        const movie_session_day = event.sessions.filter(session => session.date.substring(0,8) == day.format("YYYYMMDD"));
        if(movie_session_day && movie_session_day.length>0){
          let common_features = []; // features communes aux séances, on les met sur le film
          movie_session_day.forEach((session,index) => {
            let date_session = session.date.substring(0,8);
            let time_session = session.date.substring(8,12);
            if(date_session == today.format("YYYYMMDD") && time_session < time_now){
              movie_session_day.splice(index,1);
            }
            if(event.art_et_essai_actif){
              if(!session.features){
                  session.features = [];
              }
              if(session.features.indexOf("art_et_essai")<=0){
                  session.features.push("art_et_essai");
              }
            }
            if(session.seat_booking && session.features.indexOf("hall_map")<0){
              session.features.push("hall_map");
            }
            if(session.features && session.features.length>0){
              if(common_features.length<=0){
                common_features = Object.assign([],session.features);
              }else{
                common_features.forEach(feature => {
                  if($.inArray(feature,session.features)<0){
                    var index = common_features.indexOf(feature);
                    if(index>=0){
                      common_features.splice(index,1);
                    }
                  }
                });
              }
            }
          });

          if(movie_session_day.length > 0){
            let my_event = Object.assign({},"");
            my_event.id = event.id;
            my_event.title = event.title;
            my_event.certification = this.ParseCertification(event.certification_id);
            my_event.features = common_features;
            my_event.custom_tags = event.custom_tags ? event.custom_tags : [];

            tab_date.push({
              date : day,
              sessions : movie_session_day
            });
          }
        }
      }
      if(tab_date.length>0){
        results.events.push({
          event : event,
          data : tab_date
        })
      }
    });

    // Tri des films par nombre de séances
    // results.events.sort(function(a,b){
    //   if(a.data.length<b.data.length){
    //       return 1;
    //   };
    //   if(a.data.length>b.data.length){
    //       return -1;
    //   };
    //   return 0;
    // });

    // Tri des films par date de la première séance
    results.events.sort(function(a,b){
      if(a.data[0].date.format("YYYYMMDD")<b.data[0].date.format("YYYYMMDD")){
          return -1;
      };
      if(a.data[0].date.format("YYYYMMDD")>b.data[0].date.format("YYYYMMDD")){
          return 1;
      };
      return 0;
    });

    return results;
  }

  get_movie_sessions_selected_date(iParam){
    // console.log("get_movie_sessions_selected_date", iParam)
    let movie_id = iParam.movie_id;
    let selected_date = iParam.selected_date;
    let today = moment().format("YYYYMMDD");
    let time_now = moment().format("HHmm");
    let sessions = [];
    this.m_prog.schedule.events.forEach((movie) => {
      if(movie.id != movie_id){
        return;
      }
      movie.sessions.forEach(session => {
        let date_session = session.date.substring(0,8);
        let time_session = session.date.substring(8,12);
        if(date_session == selected_date && (date_session > today || (date_session == today && time_session >= time_now))){          
          sessions.push(session)
        }
      });
    });

    return sessions;
  }

  async get_sessions_selected_date(iDate){
    // console.log("get_sessions_selected_date", iDate)
    let selected_date = iDate;
    let today = moment().format("YYYYMMDD");
    let time_now = moment().format("HHmm");
    let sessions = [];
    this.m_prog.schedule.events.forEach((movie) => {
      movie.sessions.forEach(session => {
        let date_session = session.date.substring(0,8);
        let time_session = session.date.substring(8,12);
        if(date_session == selected_date && (date_session > today || (date_session == today && time_session >= time_now))){
          session.data_movie = movie;
          sessions.push(session)
        }
      });
    });

    // Tri des séances par date/heure
    sessions.sort(function(a,b){
      if(a.date<b.date){
          return -1;
      };
      if(a.date>b.date){
          return 1;
      };
      return 0;
    });

    return sessions;
  }

  ParseCertification(iCertification) {
    let json = {};
    switch (iCertification){
        case "ALL":
          json.text = _l("Tous public");
          // json.img="https://static.monnaie-services.com/www-img/session/certifications/a.png";
          break;
        case 1:
        case "R12":
            // chInterdiction=gl_fic_langue.index.interdictionFilm.M12;
            json.text = _l("Interdit -12 ans");
            json.img="https://static.monnaie-services.com/www-img/session/certifications/_12.png";
            break;
        case 2:
        case "A12":
            // chInterdiction=gl_fic_langue.index.interdictionFilm.$broadcastA12;
            json.text = _l("Avertissement -12 ans");
            json.img="https://static.monnaie-services.com/www-img/session/certifications/_12.png";
            break;
        case 3:
        case "R16":
            // chInterdiction=gl_fic_langue.index.interdictionFilm.M16;
            json.text = _l("Interdit -16 ans");
            json.img="https://static.monnaie-services.com/www-img/session/certifications/_16.png";
            break;
        case 4:
        case "A16":
            // chInterdiction=gl_fic_langue.index.interdictionFilm.A16;
            json.text = _l("Avertissement -16 ans");
            json.img="https://static.monnaie-services.com/www-img/session/certifications/_16.png";
            break;
        case 5:
        case "R18":
            // chInterdiction=gl_fic_langue.index.interdictionFilm.M18;
            json.text = _l("Interdit -18 ans");
            json.img="https://static.monnaie-services.com/www-img/session/certifications/_18.png";
            break;
        case 6:
            // chInterdiction=gl_fic_langue.index.interdictionFilm.A18;
            json.text = _l("Avertissement -18 ans");
            json.img="https://static.monnaie-services.com/www-img/session/certifications/_18.png";
            break;
        case 7:
            // chInterdiction=gl_fic_langue.index.interdictionFilm.TP;
            json.img=null;
            break;
        case 8:
            // chInterdiction=gl_fic_langue.index.interdictionFilm.ATP;
            json.img=null;
            break;
        default:
            break;
    };
    return json;
  }

  player_trailer(iUrl) {
    // console.log("player_trailer", iUrl)

    var parent=$("html");
    var url_video=iUrl;
    url_video = url_video.replace("/ld","/sd")
    
    var $container_player=$("<div/>").addClass("container-player").appendTo(parent).on("click",function(){
        //Animation de fermeture
        $container_player.removeClass("open");
        $container_player.remove();
    });
        var $row_player=$("<div/>").addClass("row w-100 m-0").appendTo($container_player);
            var $col_player=$("<div/>").addClass("col-md-12 m-auto p-0 d-flex").appendTo($row_player);
                var $player=$("<video/>").attr({"id":"player","controls":true,"preload":"metadata","src":url_video,autoplay:true}).appendTo($col_player).on("click",function(e){
                    e.preventDefault();
                    e.stopPropagation();
                })
    
    //Animation d'ouverture
    $container_player.addClass("open");
  }

  get_movie_data(movieID) {
    return this.m_prog.schedule.events.filter(event => event.id == movieID)[0];
  }

  get_movie_data_by_sessionID(sessionID) {
    // console.log("get_movie_data_by_sessionID - this.m_prog", this.m_prog)
    let movie_to_return;
    this.m_prog.schedule.events.forEach(event => {
      if(!event.sessions){
        gl_api.n_log('Prog.js - get_movie_data_by_sessionID - event sans session => ',event);
        // console.log("get_movie_data_by_sessionID - event sans session", event)
        return;
      }else{
        event.sessions.forEach(session => {
          if(session.id == sessionID){
            movie_to_return = event;
            return;
          }
        });
      }
    });
    return movie_to_return;
  }

  // On cherche les séances mise en avant
  get_session_headline() { 
    // console.log("get_session_headline",this.m_prog)
    let tab_sessions_headline = [];
    const events = this.m_prog.schedule.events;
    events.forEach(event => {
      event.sessions.forEach(session => {
        if(session.features.indexOf("headline")>=0){
          let my_event = Object.assign({},event);
          let my_session = Object.assign({},session);
          let date_session = my_session.date.substring(0,8);
          let hour_session = my_session.date.substring(8,12);
          if(date_session == moment().format("YYYYMMDD") && hour_session < moment().format("HHmm")){
            return;
          }
          delete my_event.sessions;
          my_session.data_movie = my_event;
          tab_sessions_headline.push(my_session)
        }
      });
    });
    return tab_sessions_headline;
  }

  async get_session_data(sessionID) {
    let session_to_return = Object.assign({},null);
    this.m_prog.schedule.events.forEach(event => {
      if(!event.sessions){
        gl_api.n_log('Prog.js - get_session_data - event sans session => ',event);
        // console.log("get_session_data - event sans session", event)
        return;
      }else{
        event.sessions.forEach(session => {
          if((session.id == sessionID) || session.ems.id == sessionID){
            session_to_return = Object.assign({},session);
            session_to_return.movie = event;
            return;
          }
        });
      }      
    });

    if(!session_to_return.ems){
      return false
    }

    await gl_api.ems_get_session_prices(session_to_return.ems.id).then((s) => {
        let session = s.session;
        session_to_return.ems_id = session.id;
        session_to_return.prices = session.prices;
        session_to_return.visible = session.visible;
        session_to_return.web_cancel = session.web_cancel;
        session_to_return.price_types = session.price_types;
        session_to_return.exo = session.exo ? session.exo : false;
        session_to_return.first_part_duration = session.first_part_duration ? session.first_part_duration : 0;
        session_to_return.majo_interne = 0;
        session_to_return.majo_externe = 0;
        session_to_return.majo_laser = 0;
        session_to_return.montant_lunette_ext = 0;
        if(session.lst_majo){
          session_to_return.lst_majo = session.lst_majo;
          if(session.lst_majo.int){
            session.lst_majo.int.forEach(majInt => {
              if(majInt.id == "01"){
                  session_to_return.is_session_3D = true;
              }
              session_to_return.majo_interne += parseFloat(majInt.amount);
            });
          }
          if(session.lst_majo.ext){
            session.lst_majo.ext.forEach(majExt => {
              switch(parseInt(majExt.id)){
                  case 1:
                      session_to_return.is_session_3D = true;
                      session_to_return.is_session_3D_passive = true;
                      session_to_return.montant_lunette_ext = parseFloat(majExt.amount);
                      break;
                  case 2:
                      session_to_return.is_session_3D = true;
                      session_to_return.is_session_3D_passive = true;
                      session_to_return.majo_externe += parseFloat(majExt.amount);
                      break;
                  case 5:
                      session_to_return.majo_laser = parseFloat(majExt.amount);
                      break;
                  default:
                      session_to_return.majo_externe += parseFloat(majExt.amount);
                      break;
              }
            });
          }
        }
    }); 

    // Si plan de salle, on appel le WS pour connaitre les sièges dispos
    if(session_to_return.seat_booking){
      Overlay.$show({
        "text" : "Récupération du plan de salle"
      });
      let result_api;
      try{
          result_api = await gl_api.ems_get_session_seats(session_to_return.ems.id, session_to_return.hall_id);
          if(result_api.data_hall_map.error){
              Overlay.hide();
              Swal.fire({
                  icon:"info",
                  title:_l("Récupération du plan de salle"),
                  showCloseButton : true,
                  text: _l(result_api.data_hall_map.error),
                  heightAuto : false,
                  scrollbarPadding : false,
                  allowOutsideClick : false,
                  customClass: {
                      icon : "align-items-center"
                  }
              }).then((result) => {
                // var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : this.website_active ? "home" : "schedule";
                var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : "home";
                window.location.replace("#"+home_page_id);
              });
              return;
          }
      }catch(e){
          Overlay.hide();
          Swal.fire({
              icon:"info",
              title:_l("Récupération du plan de salle"),
              showCloseButton : true,
              text: _l(e),
              heightAuto : false,
              scrollbarPadding : false,
              allowOutsideClick : false,
              customClass: {
                  icon : "align-items-center"
              }
          }).then((result) => {
            // var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : this.website_active ? "home" : "schedule";
            var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : "home";
            window.location.replace("#"+home_page_id);
          });
          return;
      }
      session_to_return.data_hall_map = result_api.data_hall_map;
      Overlay.hide();
    }

    return session_to_return;
  }

  async $calendar_prog(iParam) {
    // console.log("$calendar_prog", iParam)
    const self = this;
    const $parent = iParam.$parent;
    const first_day = iParam.first_day;
    const num_cine = iParam.num_cine && iParam.num_cine != "null" ? iParam.num_cine : null;
    let first_item = true;
    let isMouseDown = false;
    let startX;
    let scrollLeft;
    let has_day_with_prog = false;
    let common_features = [];

    // Si on est sur la page d'un film, on va chercher uniquement pour ses séances
    let tab_events = gl_config.type == "site" ? Object.assign([],this.m_prog.schedule.events) : Object.assign([],this.m_prog.events);
    if(iParam.movie_id) {
      tab_events = tab_events.filter(event => event.id == iParam.movie_id)
    }
    if(gl_config.type == "chain" && tab_events[0].sessions > 0){
      try{
          let res_api = await gl_api.get_event_sessions({
              "event" : iParam.movie_id
          });
          // console.log("Result get_event_sessions",res_api)
          tab_events[0].sessions = res_api;
      }catch(err){
          Overlay.hide();
          Swal.fire({
              icon:"warning",
              title:"Récupération des séances",
              showCloseButton : true,
              text: _l(err.data ? err.data.message : err),
              heightAuto : false,
              scrollbarPadding : false,
              allowOutsideClick : false,
              customClass: {
                  icon : "align-items-center"
              }
          }).then((result) => {
              window.location.replace("#home");
          });
          return;
      }
    }

    var $date_slider_container=$("<div>").addClass("slider_container slider_date").appendTo($parent);
      var $date_slider=$("<div>").addClass("slider-content").appendTo($date_slider_container);
      for(var i=0 ; i<7 ; i++){
        let valid_item = false; 
        let date = first_day;
        var $slider_item=$("<div/>").addClass("slider-item d-flex flex-column").data({"date":date.format("YYYYMMDD")}).appendTo($date_slider);

        if(date.isSame(moment(), "day")){
            $("<span/>").addClass("m-auto font-2 colored_text").text(_l("Auj.")).appendTo($slider_item);
        }else{
            $("<span/>").addClass("mx-auto colored_text").addClass("capitalize font-1_25").text(date.format("ddd")).appendTo($slider_item);
            $("<span/>").addClass("mx-auto").addClass("font-2 bold").text(date.format("DD")).appendTo($slider_item);
            $("<span/>").addClass("mx-auto").addClass("capitalize").text(date.format("MMM")).appendTo($slider_item);
        } 

        // On va regarder si il y a de la prog pour ce jour là   
        tab_events.forEach(event => {   
          if(num_cine){
            if(event.sites.filter(site => site.id == num_cine).length <= 0){
              return;
            }
          }
          if(event.sessions.length > 0 && event.sessions.filter(s => s.date.substring(0,8) == date.format("YYYYMMDD")).length > 0){
            // valid_item = true;
            has_day_with_prog = true;

            // Recherche des features communes à tous les films des 7 jours
            if(event.art_et_essai_actif){
              if(!event.features || !event.features.length){
                event.features = [];
              }
              event.features.push("art_et_essai");
            }
            if(event.features && event.features.length > 0){
              event.features.forEach(feature => {
                if(common_features.indexOf(feature) < 0){
                  common_features.push(feature)
                }
              });
            }

            event.sessions.forEach(session => {
              if(num_cine){
                if(session.site_id && session.site_id != num_cine){
                  // valid_item = false;
                  return;
                }
              }

              if(session.date.substring(0,8) != date.format("YYYYMMDD")){
                return;
              }
              
              if(session.date.substring(0,8) == moment().format("YYYYMMDD") && session.date.substring(8) <= moment().format("HHmm")){
                return;
              }
              if(session.seat_booking && session.features.indexOf("hall_map")<0){
                session.features.push("hall_map");
              }
              if(session.features && session.features.length>0){
                session.features.forEach(feature => {
                  if(common_features.indexOf(feature) < 0){
                    common_features.push(feature)
                  }
                });
              }
              
              valid_item = true;
            });
          }
        });
        
        $slider_item.on("click",(e) => {
            if(!self.slider_dragging){
              $(".slider-item.active").removeClass("active");
              var $e = $(e.currentTarget);
              $e.addClass("active");
              iParam.action($e.data("date"));
            }
        });
        // Si premier élément où il y a de la prog
        if(first_item && valid_item){
            first_item = false;
            $slider_item.addClass("active");
            $slider_item.trigger("click");
        }
        if(!valid_item){
          $slider_item.addClass("disabled no_prog");
          $slider_item.off("click");
        }
        
        first_day.add(1,"day");        

        self.scrollOffset = $slider_item.width();
      }

      iParam.callback({
        "common_features" : common_features
      })

      // Si aucun jour n'a de prog on clic sur le premier élément du calendrier
      // Affichera pas de séance ce jour
      if(!has_day_with_prog){
        const elem = $date_slider.first().children()[0];
        if(!$(elem)){
          return;
        }
        $(elem).on("click",(e) => {
            if(!self.slider_dragging){
              $(".slider-item.active").removeClass("active");
              var $e = $(e.currentTarget);
              $e.addClass("active");
              iParam.action($e.data("date"));
            }
        });
        $(elem).trigger("click");
        $(elem).off("click");
      }

      const sliderElement = $date_slider.get(0);
      sliderElement.addEventListener("mousedown", (event) => {
          event.preventDefault()
          isMouseDown = true;
          startX = event.pageX - sliderElement.offsetLeft;
          scrollLeft = sliderElement.scrollLeft;
          self.slider_dragging = false;
      });
      sliderElement.addEventListener("mouseleave", () => {
          isMouseDown = false;
      });
      sliderElement.addEventListener("mouseup", () => {
          isMouseDown = false;
      });
      sliderElement.addEventListener("mousemove", (event) => {
          if (!isMouseDown) return;
          event.preventDefault();
          const x = event.pageX - sliderElement.offsetLeft;
          const walk = (x - startX) * 1;
          sliderElement.scrollLeft = scrollLeft - walk;

          if(walk < -25 || walk > 25){
            self.slider_dragging = true;
          }
      });
      sliderElement.addEventListener("touchstart", (event) => {
          isMouseDown = true;
          startX = event.touches[0].pageX - sliderElement.offsetLeft;
          scrollLeft = sliderElement.scrollLeft;
      });
      sliderElement.addEventListener("touchend", () => {
          isMouseDown = false;
      });
      sliderElement.addEventListener("touchmove", (event) => {
          if (!isMouseDown) return;
          event.preventDefault();
          const x = event.touches[0].pageX - sliderElement.offsetLeft;
          const walk = (x - startX) * 1;
          sliderElement.scrollLeft = scrollLeft - walk;
      });
  }

  $btn_air_datepicker(iParam) {
    // console.log("$btn_air_datepicker", iParam);
    const enables_dates = iParam.enables_dates ? iParam.enables_dates : [];
    var $wrap=$("<div/>").addClass("d-flex flex-column h-100").appendTo(iParam.$parent);
      var $btn=$("<div/>").addClass("btn_dropdown d-flex flex-column dropdown-toggle position-relativ").attr({"type":"button", "data-bs-toggle":"dropdown", "data-bs-auto-close":"outside", "aria-expanded":false}).appendTo($wrap);
        var $icon=$("<img/>").addClass("icon_svg mx-auto").attr({"src":"https://static.monnaie-services.com/fontawesome/svgs/regular/calendar-days.svg", "alt":""}).appendTo($btn);
        // var $label=$("<div/>").addClass("label mx-auto text-center").text(_l("Calendrier")).appendTo($btn);

    var $html_content = $("<div/>").attr({"id":iParam.id});
    
    MSDropDown.create({
        id: "calendar_dropdown",
        items: [$html_content],
    }).appendTo($wrap);  

    // Init air datepicker
    this.air_dp = new AirDatepicker('#'+iParam.id, {
        inline: true,
        locale: localeFr,
        selectedDates : [moment(iParam.selectedDate).format("YYYY-MM-DD")],
        buttons : [
          "clear",
          {
            content : _l("Aujourd'hui"),
            onClick : (dp) => {
              dp.selectDate(moment());
            }
          }
        ],
        onSelect: (cb) => {
          if(cb.date){
            // Appel du callback "onSelect" de la classe parente reçu en paramètre
            iParam.onSelect(moment(cb.date).format("YYYYMMDD"));
          }
        },
        disabledDates: "",
        onRenderCell: ({date, cellType}) => {
          // On rends les jours sans prog non cliquable
          return {
              disabled: (enables_dates.length <= 0 || enables_dates.indexOf(moment(date).format("YYYYMMDD")) >= 0) ? false : true,
          }
        }
    });
  }

  $btn_filter_prog(iParam) {
    // console.log("$btn_filter_prog", iParam);
    // this.selected_features_filter = iParam.selected_features_filter;

    var $wrap=$("<div/>").addClass("d-flex flex-column h-100").attr({"id":iParam.id}).appendTo(iParam.$parent);
      var $btn=$("<div/>").addClass("btn_dropdown d-flex flex-column dropdown-toggle position-relativ").attr({"type":"button", "data-bs-toggle":"dropdown", "data-bs-auto-close":"outside", "aria-expanded":false}).appendTo($wrap);
        var $icon=$("<img/>").addClass("icon_svg mx-auto").attr({"src":"https://static.monnaie-services.com/fontawesome/svgs/regular/sliders.svg", "alt":""}).appendTo($btn);
        var $nb_filter=$("<div/>").addClass("nb_filter").appendTo($btn)

    var $html_content = $("<div/>").addClass("px-1");
      var $row=$("<div/>").addClass("row mb-2 mb-md-4").appendTo($html_content);
      iParam.features.forEach(feature => {
        if(feature == "headline"){
          return;
        }
        let feature_url = "https://static.monnaie-services.com/www-img/session/features/"+feature+".png";
        var $col=$("<div/>").addClass("col-4 d-flex").appendTo($row);
          var $wrap=$("<div/>").addClass("wrap_feature d-flex mx-auto").data({"feature":feature}).appendTo($col);
            var $img=$("<img/>").addClass("features pointer").attr({"src":feature_url, "title":_l('#session_feature_'+feature) , "alt":feature}).appendTo($wrap);

        $wrap.on("click",(e) => {
          var $elem = $(e.currentTarget);
          if($elem.hasClass("selected")){
            $elem.removeClass("selected");
          }else{
            $elem.addClass("selected");
          }
          let selected_features = [];
          $("#"+iParam.id+" .wrap_feature").each((i,e) => {
            if($(e).hasClass("selected")){
              selected_features.push($(e).data("feature"))
            }
          })
          iParam.onSelect(selected_features);
          if(selected_features.length > 0){
            $("#"+iParam.id+" .btn_dropdown .nb_filter").show();
            $("#"+iParam.id+" .btn_dropdown .nb_filter")[0].textContent = selected_features.length;
          }else{
            $("#"+iParam.id+" .btn_dropdown .nb_filter").hide();
          }
        })
      });

      var $row=$("<div/>").addClass("row my-1 my-md-2").appendTo($html_content);
        var $col=$("<div/>").addClass("col-10 mx-auto text-center pointer").appendTo($row);
          var $btn=$("<div/>").addClass("btn w-100").text(_l("Effacer les filtres")).appendTo($col);
          $btn.on("click", () => {
            $("#"+iParam.id+" .wrap_feature").each((i,e) => {
              $(e).removeClass("selected")
            })
            iParam.onSelect([]);
            $("#"+iParam.id+" .btn_dropdown .nb_filter").hide();
            $(".dropdown-menu#filter_prog_dropdown").removeClass("show");
          });

    MSDropDown.create({
        id: "filter_prog_dropdown",
        items: [$html_content],
    }).appendTo($wrap);  
  }

  async get_events_by_features(iParam) {
    // console.log("get_events_by_features", iParam)
    const selected_date = iParam.date;
    const selected_features = iParam.features;
    let matched_events = [];

    let today = moment().format("YYYYMMDD");
    let time_now = moment().format("HHmm");

    // let tab_events = gl_config.type == "site" ? this.m_prog.schedule.events : gl_config.type == "chain" ? this.m_prog.events : [];
    let tab_events = gl_config.type == "site" ? Object.assign([],this.m_prog.schedule.events) : gl_config.type == "chain" ? Object.assign([],this.m_prog.events) : [];
    if(iParam.movie_id) {
      tab_events = tab_events.filter(event => event.id == iParam.movie_id)
      if(gl_config.type == "chain" && tab_events[0].sessions > 0){
        try{
            let res_api = await gl_api.get_event_sessions({
                "event" : iParam.movie_id
            });
            // console.log("Result get_event_sessions",res_api)
            tab_events[0].sessions = res_api;
        }catch(err){
            Swal.fire({
                icon:"warning",
                title:"Récupération des séances",
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                window.location.replace("#");
            });
            return;
        }
      }
    }

    tab_events.forEach(event => {
      let features_to_match = [];
      if(event.features && event.features.length > 0){
        event.features.forEach(feature => {
          if(features_to_match.indexOf(feature) < 0){
            features_to_match.push(feature)
          }
        });
      }

      if(event.sessions){
        event.sessions.forEach(session => {
          let date_session = session.date.substring(0,8);
          let time_session = session.date.substring(8,12);

          if(session.seat_booking && session.features.indexOf("hall_map")<0){
            session.features.push("hall_map");
          }

          if(date_session == selected_date && (date_session > today || (date_session == today && time_session >= time_now))){
            if(session.features && session.features.length>0){
            session.features.forEach(feature => {
                if(features_to_match.indexOf(feature) < 0){
                  features_to_match.push(feature)
                }
              });
            }
          }
        });
      }

      // console.log(event)
      // console.log(features_to_match)
      selected_features.forEach(feature => {
        if(features_to_match.indexOf(feature) >= 0){
          matched_events.push(event)
        }
      });
      
    });

    // console.log(matched_events)

    return matched_events;
  }

  // Procédure qui retourne une liste de films (events)
  async filter_events(iParam){
    // {
    //   "categorie" : "video_3d",
    //   "numcine_selected" : "EMS9997", // null
    //   "website_type" : "site" // chain
    // }
    // console.log("Prog - filter_events", iParam, this.m_prog)
    moment.locale(gl_config.site ? gl_config.site.lang : "fr")

    let movies_list = [];
    const categorie = iParam.categorie;
    const num_cine_selected = iParam.num_cine_selected && iParam.num_cine_selected != "null" ? iParam.num_cine_selected : null;
    const website_type = iParam.website_type;
    const data = iParam.data;
    let prog_cine = website_type == "site" ? this.m_prog.schedule.events : [];
    let sb_cine = website_type == "site" ? this.m_prog.schedule.super_billets : [];
    let chain_events = website_type == "chain" ? this.m_prog.events : [];
    let chain_sb = website_type == "chain" ? this.m_prog.super_billets : [];
    
    const currentDate = moment();
    let next_week_start = moment(); 
    let nb_day_to_next_week_start = 0;
    switch(currentDate.isoWeekday()){
      case 1:
        nb_day_to_next_week_start = 1;
        break;
      case 2:
        nb_day_to_next_week_start = 0;
        break;
      case 3:
        nb_day_to_next_week_start = 6;
        break;
      case 4:
        nb_day_to_next_week_start = 5;
        break;
      case 5:
        nb_day_to_next_week_start = 4;
        break;
      case 6:
        nb_day_to_next_week_start = 3;
        break;
      case 7:
        nb_day_to_next_week_start = 2;
        break;
      default:
        break;
    }
    next_week_start.add(nb_day_to_next_week_start, 'days');

    let categorie_name = categorie;
    if(categorie_name.indexOf("customsTags_") >= 0){
      categorie_name = "customsTags"
    }

    switch(categorie_name){
      case "video_3d":
      case "video_4dx":
      case "video_4k":
      case "video_imax":
      case "greta":
      case "preview":
      case "vo":
          // On va filter les films dans la prog en fonction de la categorie
          if(website_type == "site"){
              prog_cine.forEach(movie => {
                  if(movie.sessions.length > 0){
                      movie.sessions.forEach(session => {
                          if(session.features && session.features.indexOf(categorie) >= 0){
                              if(movies_list.filter(m => m.id == movie.id).length <= 0){
                                  movies_list.push(movie);
                              }
                          }
                      });
                  }
              });
          }else if(website_type == "chain"){
              chain_events.forEach(movie => {
                  if(num_cine_selected){
                      let movie_site = movie.sites.filter(site => site.id == num_cine_selected);
                      if(movie_site.length <= 0){
                          return;
                      }
                      if(!movie_site[0].features[categorie]){
                          return;
                      }
                  }
                  if(movie.features[categorie]){
                      if(movies_list.filter(m => m.id == movie.id).length <= 0){
                          movies_list.push(movie);
                      }
                  }
              });
          }
          break;
      case "art_et_essai":
          if(website_type == "site"){
              prog_cine.forEach(movie => {
                  if(movie.art_et_essai_actif){
                      movies_list.push(movie);
                  }
              });
          }else if(website_type == "chain"){
              chain_events.forEach(movie => {
                  if(num_cine_selected){
                      let movie_site = movie.sites.filter(site => site.id == num_cine_selected);
                      if(movie_site.length <= 0){
                          return;
                      }
                  }
                  if(movie.art_et_essai_actif){
                      if(movies_list.filter(m => m.id == movie.id).length <= 0){
                          movies_list.push(movie);
                      }
                  }
              });
          }
          break;
      case "custom":
          movies_list = data.config.movies;
          break;
      case "show":
          if(website_type == "site"){
              prog_cine.forEach(movie => {
                  if(movie.id.substring(0,4) == "emsx"){
                      movies_list.push(movie);
                  }
              });
          }else if(website_type == "chain"){
              chain_events.forEach(movie => {
                  if(num_cine_selected){
                      let movie_site = movie.sites.filter(site => site.id == num_cine_selected);
                      if(movie_site.length <= 0){
                          return;
                      }
                  }
                  if(movie.id.substring(0,4) == "emsx"){
                      if(movies_list.filter(m => m.id == movie.id).length <= 0){
                          movies_list.push(movie);
                      }
                  }
              });
          }
          break;
      case "shortly":
          // console.log(currentDate.day())
          // console.log(moment().day(3))
          // console.log(moment().day(9)) // next Tuesday (3 + 6)
          // console.log(moment().day(10)) // next Wednesday (3 + 7)
          // console.log(moment().day(17)) // 2 Wednesdays from now (3 + 7 + 7)
          if(website_type == "site"){
              prog_cine.forEach(movie => {
                  if(movie.sessions.length > 0){
                    // On regarde dans un premier temps, si le film à des séances avant le prochain mercredi
                    const sessions_this_week = movie.sessions.filter((session) => {
                      const session_date = moment(session.date, "YYYYMMDDHHmmss");
                      if(currentDate.day() < 3){
                        return (session_date.isSameOrBefore(moment().day(2)));
                      }else{
                        return (session_date.isSameOrBefore(moment().day(9)));
                      }
                    });

                    if(sessions_this_week.length > 0){
                      return;
                    }

                    const valid_sessions = movie.sessions.filter((session) => {
                        const session_date = moment(session.date, "YYYYMMDDHHmmss");
                        if(currentDate.day() < 3){
                          return (session_date.isSameOrAfter(moment().day(2)));
                        }else{
                          return (session_date.isSameOrAfter(moment().day(9)));
                        }
                    });
                    if(valid_sessions.length > 0 && movies_list.filter(m => m.id == movie.id).length <= 0){
                        movies_list.push(movie);
                    }
                  }
              });
          }else if(website_type == "chain"){
              chain_events.forEach(movie => {
                  const first_date = moment(moment(movie.first_date).format("YYYYMMDD"), "YYYYMMDD");
                  if(num_cine_selected){
                      let movie_site = movie.sites.filter(site => site.id == num_cine_selected);
                      if(movie_site.length <= 0){
                          return;
                      }
                  }
                  if(first_date.isSameOrAfter(moment().day(10))){
                      if(movies_list.filter(m => m.id == movie.id).length <= 0){
                          movies_list.push(movie);
                      }
                  }
              });
          }
          break;
      case "superbillet":
        if(website_type == "site"){
          sb_cine.forEach(super_billets => {
            movies_list.push(super_billets);
          });
        }else if(website_type == "chain"){
          chain_sb.forEach(super_billets => {
            if(num_cine_selected && super_billets.site_id != num_cine_selected){
              return;
            }
            movies_list.push(super_billets);
          });
        }
        break;
      case "week_release":
        if(website_type == "site"){
            prog_cine.forEach(movie => {
                if(!movie.release_date){
                    return;
                }
                if(moment().weekday() < 2){
                    // Si on est lundi ou mardi, on veut du mercredi précédent au mardi en cours
                    if(!moment(movie.release_date, "YYYYMMDD").isBetween(moment().day(-5), moment().day(2))){
                        return;
                    }
                }else{
                    // Si on est de mercredi à dimanche, on veut du mercredi en cours au mardi suivant
                    if(!moment(movie.release_date, "YYYYMMDD").isBetween(moment().day(2), moment().day(9))){
                        return;
                    }
                }
                movies_list.push(movie);
            });
        }else if(website_type == "chain"){
            chain_events.forEach(movie => {
                if(!movie.release_date){
                    return;
                }
                if(num_cine_selected){
                    let movie_site = movie.sites.filter(site => site.id == num_cine_selected);
                    if(movie_site.length <= 0){
                        return;
                    }
                }
                if(moment().weekday() < 2){
                    // Si on est lundi ou mardi, on veut du mercredi précédent au mardi en cours
                    if(!moment(movie.release_date, "YYYYMMDD").isBetween(moment().day(-5), moment().day(2))){
                        return;
                    }
                }else{
                    // Si on est de mercredi à dimanche, on veut du mercredi en cours au mardi suivant
                    if(!moment(movie.release_date, "YYYYMMDD").isBetween(moment().day(2), moment().day(9))){
                        return;
                    }
                }
                movies_list.push(movie);
            });
        }
        break;
      case "current_week_movies":
        if(website_type == "site"){
          movies_list = prog_cine.filter((event) => {
            const validSessions = event.sessions.filter((session) => {
              const eventDate = moment(session.date, "YYYYMMDDHHmm").format("YYYYMMDD");
              return ((eventDate <= moment(next_week_start).format("YYYYMMDD")) && (currentDate.diff(moment(session.date, "YYYYMMDDHHmm"),"m") < 0));
            });
            return validSessions.length > 0;
          });
        }else if(website_type == "chain"){
          movies_list = chain_events.filter((chain_event) => {
            if(num_cine_selected && num_cine_selected !== "null" && chain_event.sites.filter(site => site.id == num_cine_selected).length <= 0){
              return false;
            }
            const first_date = moment(chain_event.first_date).format("YYYYMMDD");
            return first_date <= moment(next_week_start).format("YYYYMMDD");
          });
        }
        break;
      case "customsTags" :
        const tag = categorie.split("customsTags_")[1];
        if(!tag){
          return [];
        }
        if(website_type == "site"){
          prog_cine.forEach(movie => {
            if(movie.custom_tags && movie.custom_tags.indexOf(tag) >= 0){
              movies_list.push(movie);
            }
          });
        }else if(website_type == "chain"){

        }
        break;
      default:
          break;
    }

    return movies_list;
  }
}
